import React, { Component } from 'react'
import "./pagination.scss"
import Icon from "../icon/icon.component.jsx";
import { FormattedMessage } from "react-intl";

class NoResult extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            noContainer: this.props.noContainer || false,
            noButton: this.props.noButton || false,
            title: this.props.title || <FormattedMessage
                id="list.empty.no_result_title"
                defaultMessage="No result!"
            />,
            message: this.props.message || <FormattedMessage
                id="list.empty.no_result_description"
                defaultMessage="No item found for your search."
            />,
            className: this.props.className || 'py-3'
        }
        this.onClearFilters = this.props.onClearFilters || function () { }
        this.handleClearFilters = this.handleClearFilters.bind(this)
    }

    handleClearFilters(e) {
        e.preventDefault()
        this.onClearFilters()
    }

    render() {
        return <div className={"row ui-has-modules " + this.state.className}>
            <div className={"col-12 mb-0 " + (this.state.noContainer ? '' : 'ui-module')}>
                <div className={'w-100 d-flex align-items-center justify-content-center my-2'}>
                    <img className={'mr-4'} src={'/images/no_data.svg'} width={'120px'} />
                    <div >
                        <p className={'h2 custom-lead text-custom-primary mb-0'}>
                            {this.state.title}
                        </p>
                        <p className={'text-center h6 mb-3'}>
                            {this.state.message}
                        </p>
                        {!this.state.noButton ? <p >
                            <button className={'btn btn-sm btn-outline-primary'} onClick={this.handleClearFilters}>
                                <Icon value={'eraser'} className={'mr-1'} />
                                <FormattedMessage
                                    id="list.empty.clear_filter_btn"
                                    defaultMessage="Clear filters"
                                />
                            </button>
                        </p> : ''}
                    </div>

                </div>
            </div>
        </div>
    }
}

export default NoResult





// WEBPACK FOOTER //
// ./src/common/listing/noresult.component.jsx